import {RouteProps} from 'config/navigation';

import Additionals from './additionals';
import CreateAdditional from './create-additional';
import EditAdditional from './edit-additional';
import {IoBagHandle} from 'react-icons/io5';

const additionalsPages: RouteProps = {
  name: 'Adicionais',
  path: 'additionals',
  permission: 'additionals.findAll',
  icon: <IoBagHandle />,
  subRoutes: [
    {
      path: '',
      element: <Additionals />,
      permissions: ['additionals.findAll'],
    },
    {
      path: 'create',
      element: <CreateAdditional />,
      permissions: ['additionals.findOne'],
    },
    {
      path: ':id',
      element: <EditAdditional />,
      permissions: ['additionals.findOne'],
    },
  ],
};

export default additionalsPages;
